import { Flexbox, StyledButton, Text } from '@morressier/ts';
import styled from 'styled-components';
import { logEvent } from 'utils/eventTracking';

const Container = styled(Flexbox)`
  width: 100%;
  padding: 1rem;
  border-radius: 3px;
  border: 1px solid #d4d5d6;
`;

const TextContainer = styled.div``;

interface Props {
  organizationId: string;
}

const SciMeetingsBanner = ({ organizationId }: Props) => (
  <Container justifyContent="space-between" className="mt4">
    <TextContainer className="mr4">
      <Text size="h5_new" fontWeight="semiBold">
        Publish on Scimeetings
      </Text>
      <Text color="grey">
        Make a genuine impact in chemistry. Share your research with over 150,000 ACS members and
        join the leading names in chemistry.
      </Text>
    </TextContainer>
    <Flexbox alignItems="center">
      <StyledButton
        color="primary"
        as="a"
        href={`/organization-submission/${organizationId}`}
        visuallyDisabled={false}
        onClick={() => {
          logEvent('DPC_CLICKED_PUBLISH_ON_SCIMEETINGS');
        }}
      >
        Submit
      </StyledButton>
    </Flexbox>
  </Container>
);

export default SciMeetingsBanner;
